// Styles du parc matériel, aux couleurs de la charte (pétrole, crème, validation).

export const fieldStyle = {
    width: "100%",
    border: "1px solid #D9D2C4",
    borderRadius: "8px",
    padding: "9px 10px",
    fontSize: "13px",
    color: "#122A26",
    background: "white",
    boxSizing: "border-box",
};
export const labelStyle = { display: "block", fontSize: "12px", fontWeight: 800, color: "#5A6D68", marginBottom: "5px" };
export const buttonPrimary = { padding: "9px 13px", borderRadius: "8px", border: 0, background: "#0C3B3C", color: "white", fontWeight: 800, cursor: "pointer" };
export const buttonSecondary = { padding: "9px 13px", borderRadius: "8px", border: "1px solid #D9D2C4", background: "white", color: "#0C3B3C", fontWeight: 800, cursor: "pointer" };
export const panelStyle = { background: "white", border: "1px solid #E1DCCF", borderRadius: "8px", boxShadow: "0 1px 2px rgba(18, 42, 38, 0.05)", minWidth: 0 };
export const fileInputStyle = { width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box", color: "#122A26" };
export const parkCellStyle = { padding: "12px", borderBottom: "1px solid #F1EEE6" };
export const DOCUMENT_ACCEPT = ".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
